import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1761914410572-02614b575847?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBkb2N1bWVudHMlMjBkZXNrJTIwYWNjb3VudGluZ3xlbnwwfHx8fDE3Nzg2NTcyNDF8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="pt-32 md:pt-40 pb-20 md:pb-28" data-testid="hero-section">
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-7 animate-rise">
            <div className="flex items-center gap-3 text-gold uppercase text-xs tracking-[0.25em] font-semibold mb-8">
              <span className="inline-block w-8 h-px bg-gold" />
              <span data-testid="hero-eyebrow">Ontario · Virtual Bookkeeping</span>
            </div>
            <h1
              data-testid="hero-headline"
              className="font-serif text-5xl sm:text-6xl lg:text-7xl text-navy leading-[0.95] tracking-tight"
            >
              Accurate Books. <br />
              <span className="italic text-navy/90">Clear</span> Decisions.
            </h1>
            <p
              data-testid="hero-subhead"
              className="mt-8 text-lg md:text-xl text-ink/75 max-w-xl leading-relaxed"
            >
              CRA-compliant bookkeeping for Canadian contractors and small businesses.
              Predictable monthly pricing, zero missed deadlines, and reports that
              actually inform your decisions.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={() => scrollTo("contact")}
                className="group bg-navy text-cream px-7 py-4 inline-flex items-center justify-center gap-2 hover:bg-navy2 transition-colors"
              >
                Book a Free Consultation
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => scrollTo("contact")}
                className="border border-navy text-navy px-7 py-4 hover:bg-navy hover:text-cream transition-colors"
              >
                Request a Quote
              </button>
            </div>

            <div className="mt-12 flex items-center gap-3 text-sm text-stone">
              <ShieldCheck className="h-4 w-4 text-gold" />
              <span data-testid="hero-trust-line">
                CRA-aligned · QuickBooks &amp; Xero Certified workflows · Dext-powered
              </span>
            </div>
          </div>

          <div className="lg:col-span-5 relative animate-rise delay-200">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-32 h-32 border border-gold/60 hidden md:block" />
              <img
                data-testid="hero-image"
                src={HERO_IMG}
                alt="Desk with calculator, glasses, charts and financial documents"
                className="relative w-full aspect-[4/5] object-cover grayscale-[15%] contrast-[1.02]"
                loading="eager"
              />
              <div className="absolute -bottom-6 -right-6 bg-cream border border-border p-6 max-w-[260px] hidden md:block">
                <div className="font-serif text-3xl text-navy leading-none">15<span className="text-gold">th</span></div>
                <div className="mt-2 text-xs uppercase tracking-[0.18em] text-stone">
                  Reports delivered every month — like clockwork.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
